import { render } from "./UCDayFilter.vue?vue&type=template&id=63a3214d"
import script from "./UCDayFilter.vue?vue&type=script&lang=js"
export * from "./UCDayFilter.vue?vue&type=script&lang=js"

import "./UCDayFilter.vue?vue&type=style&index=0&id=63a3214d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__